export const CREATE_ARTICLES_GET_SCHOOL_ARTICLE_LAYOUTS = 'CREATE_ARTICLES_GET_SCHOOL_ARTICLE_LAYOUTS';
export const CREATE_ARTICLES_GET_SCHOOL_ARTICLE_LAYOUTS_SUCCESS = 'CREATE_ARTICLES_GET_SCHOOL_ARTICLE_LAYOUTS_SUCCESS';
export const CREATE_ARTICLES_GET_SCHOOL_ARTICLE_LAYOUTS_FAILURE = 'CREATE_ARTICLES_GET_SCHOOL_ARTICLE_LAYOUTS_FAILURE';

export const CREATE_ARTICLES_SAVE_ARTICLE = 'CREATE_ARTICLES_SAVE_ARTICLE';
export const CREATE_ARTICLES_SAVE_ARTICLE_SUCCESS = 'CREATE_ARTICLES_SAVE_ARTICLE_SUCCESS';
export const CREATE_ARTICLES_SAVE_ARTICLE_FAILURE = 'CREATE_ARTICLES_SAVE_ARTICLE_FAILURE';

export const CREATE_ARTICLES_SUBMIT_ARTICLE = 'CREATE_ARTICLES_SUBMIT_ARTICLE';
export const CREATE_ARTICLES_SUBMIT_ARTICLE_SUCCESS = 'CREATE_ARTICLES_SUBMIT_ARTICLE_SUCCESS';
export const CREATE_ARTICLES_SUBMIT_ARTICLE_FAILURE = 'CREATE_ARTICLES_SUBMIT_ARTICLE_FAILURE';

export const CREATE_ARTICLES_APPROVE_ARTICLE = 'CREATE_ARTICLES_APPROVE_ARTICLE';
export const CREATE_ARTICLES_APPROVE_ARTICLE_SUCCESS = 'CREATE_ARTICLES_APPROVE_ARTICLE_SUCCESS';
export const CREATE_ARTICLES_APPROVE_ARTICLE_FAILURE = 'CREATE_ARTICLES_APPROVE_ARTICLE_FAILURE';

export const CREATE_ARTICLE_SET_ARTICLE_TO_EDIT = 'CREATE_ARTICLE_SET_ARTICLE_TO_EDIT';

export const CREATE_ARTICLES_PROPS_CHANGED = 'CREATE_ARTICLES_PROPS_CHANGED';